// extracted by mini-css-extract-plugin
export default {"root":"ImageResizerAndCropper__root___BuB8t","roundedCropArea":"ImageResizerAndCropper__roundedCropArea___ac5iX"};